import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function ChoixExpertLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-[#222222] tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9004 4.06641C21.1377 4.06641 23.1717 4.87998 24.7988 6.10034L13.7139 19.4226L4.66286 12.6089C5.06965 7.82919 9.13752 4.06641 14.1207 4.06641"
          fill="#FFC60E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1201 28.0667C8.50746 28.0667 4.56058 23.3926 4.56058 17.9987L12.798 24.1005C13.7133 24.8124 15.0354 24.609 15.7472 23.7954L27.5441 9.55786C28.9212 12.3122 28.561 15.4217 28.561 18.4055C28.561 23.6937 24.2898 27.965 19.0015 27.965"
          fill="#FF9900"
        />
      </svg>

      <span>Choix Expert</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
